import KfLoader from './kf-loader.riot';
import { createAction } from 'redux-actions';
export { KfLoader };
export const showLoading = createAction('@@loading/SHOW_LOADING');
export const hideLoading = createAction('@@loading/HIDE_LOADING');
export default (state = 0, action) => {
  switch (action.type) {
    case String(showLoading):
      return state += 1;
    case String(hideLoading):
      return state == 0 ? state : state -= 1;
    default:
      return state;
  }
};